import { Component } from 'react';

export default class ErrorHandling extends Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
      //logErrorToMyService(error, errorInfo);
      console.log("Compnent did catch an error.");
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return console.error("Error happened");
      }
  
      return this.props.children; 
    }
  }
